import { render, staticRenderFns } from "./locationsList.vue?vue&type=template&id=5c0570b6&scoped=true"
import script from "./locationsList.vue?vue&type=script&lang=js"
export * from "./locationsList.vue?vue&type=script&lang=js"
import style0 from "./locationsList.vue?vue&type=style&index=0&id=5c0570b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0570b6",
  null
  
)

export default component.exports